import script from "./autenticado.vue?vue&type=script&setup=true&lang=js"
export * from "./autenticado.vue?vue&type=script&setup=true&lang=js"

import "../assets/css/styles-sider.css?vue&type=style&index=0&lang=css"
import "../assets/css/autenticado-layout.css?vue&type=style&index=1&lang=css"
import "./autenticado.vue?vue&type=style&index=2&id=00836d54&lang=scss"

const __exports__ = script;

export default __exports__